import { ContactType } from '@app/queryTyping';

import { t } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';
import { PhoneFields, PhoneItemFields } from '@app/widgets/contacts-and-settings/types';

export const INTL_NUMBER_FORMAT = '+000000000000000';

export const phoneFieldDetailsGroupsMeta = {
  [PhoneItemFields.WorkPhoneFieldGroup]: {
    type: ContactType.WORKPHONE,
    submitMessage: t(
      'phone-fields-details.work.submit-message|Message text for succesful edit phone number',
      'Your work phone number has been successfully changed',
    ),
    deleteMessage: t(
      'phone-fields-details.work.delete-message|Message text for succesful delete phone number',
      'Your work phone number has been successfully removed',
    ),
    setPrimaryMessage: t(
      'phone-fields-details.work.set-primary-message|Message text succesful set phone number as primary',
      'Your work phone number has been successfully marked as primary',
    ),
  },
  [PhoneItemFields.HomePhoneFieldGroup]: {
    type: ContactType.HOMEPHONE,
    submitMessage: t(
      'phone-fields-details.home.submit-message|Message text for succesful edit phone number',
      'Your home phone number has been successfully changed',
    ),
    deleteMessage: t(
      'phone-fields-details.home.delete-message|Message text for succesful delete phone number',
      'Your home phone number has been successfully removed',
    ),
    setPrimaryMessage: t(
      'phone-fields-details.home.set-primary-message|Message text succesful set phone number as primary',
      'Your home phone number has been successfully marked as primary',
    ),
  },
  [PhoneItemFields.MobilePhoneFieldGroup]: {
    type: ContactType.MOBILEPHONE,
    submitMessage: t(
      'phone-fields-details.mobile.submit-message|Message text for succesful edit phone number',
      'Your mobile phone number has been successfully changed',
    ),
    deleteMessage: t(
      'phone-fields-details.mobile.delete-message|Message text for succesful delete phone number',
      'Your mobile phone number has been successfully removed',
    ),
    setPrimaryMessage: t(
      'phone-fields-details.mobile.set-primary-message|Message text succesful set phone number as primary',
      'Your mobile phone number has been successfully marked as primary',
    ),
  },
};

export const phoneFieldsListGroupsMeta = {
  [PhoneFields.WorkPhoneList]: {
    type: ContactType.WORKPHONE,
    title: t(
      'phone-field-list.work.title|Phone field mobile group title',
      'Work phone number',
    ),
    submitMessage: t(
      'phone-fields-list.work.submit-message|Message text for succesful submit new phone number',
      'Your work phone number has been successfully added',
    ),
  },
  [PhoneFields.HomePhoneList]: {
    type: ContactType.HOMEPHONE,
    title: t(
      'phone-field-list.home.title|Phone field home group title',
      'Home phone number',
    ),
    submitMessage: t(
      'phone-fields-list.home.submit-message|Message text for succesful submit new phone number',
      'Your home phone number has been successfully added',
    ),
  },
  [PhoneFields.MobilePhoneList]: {
    type: ContactType.MOBILEPHONE,
    title: t(
      'phone-field-list.mobile.title|Phone field mobile group title',
      'Mobile phone number',
    ),
    submitMessage: t(
      'phone-fields-list.mobile.submit-message|Message text for succesful submit new phone number',
      'Your mobile phone number has been successfully added',
    ),
  },
};
